import { useState } from 'react';
import {
  Button, FormControl,
  makeStyles, OutlinedInput, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import { setAnalytics } from '../../../utils';
import ReturnButton from '../../General/ReturnButton';

import BotMessage from './BotMessage';
import CardChat from './CardChat';
import ChatBot from './ChatBot';

const useStyles = makeStyles((theme) => ({
  backButton: {
    color: theme.palette.text.default,
    borderColor: theme.palette.text.default,
    marginTop: '39px',
    marginLeft: '5%',
    fontSize: '12px',
  },
  title: {
    color: theme.palette.text.default,
    textAlign: 'center',
    marginTop: '10px',
    marginBottom: '10px',
    fontSize: '20px',
    fontFamily: 'Raleway',
  },
  writeandSendMessageForm: {
    width: '90%',
    display: 'flex',
    maxHeight: '10%',
    flexDirection: 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  input: {
    background: theme.palette.background.card,
    borderRadius: '8px',
    marginTop: '12px',
    marginBottom: '8px',
    width: '80%',
    height: '45px',
    color: theme.palette.text.default,
    '& ::placeholder': {
      fontStyle: 'italic',
      size: '14px',
    },
  },
  sendMessageButton: {
    color: theme.palette.text.default,
    backgroundColor: theme.palette.background.secondary,
    borderRadius: '8px',
    marginTop: '12px',
    marginBottom: '8px',
    marginLeft: '1%',
    width: '19%',
    paddingLeft: '18px',
    paddingRight: '18px',
    '&:hover': {
      background: theme.palette.background.secondary,
    },
    '&:disabled': {
      color: theme.palette.common.gray,
      backgroundColor: theme.palette.background.buttonDisabled,
    },
  },
  chatEnded: {
    color: theme.palette.common.gray,
    textAlign: 'Center',
    fontSize: '15px',
    marginBottom: '5px',
  },
  writing: {
    background: theme.palette.primary.light,
    color: theme.palette.text.default,
    borderRadius: '8px',
    marginRight: 'auto',
    marginLeft: '24px',
    marginTop: '330px',
    width: 'max-content',
    maxWidth: '50%',
    padding: '7px',
  },
  messageText: {
    fontSize: '11.5px',
    fontFamily: 'Raleway',
  },
}));

function Chat({
  messages, chatBot, chatStatus, setChatStatus,
}) {
  const classes = useStyles();
  const [text, setText] = useState('');
  const [aux, setAux] = useState(0);

  const handlerChangeWriteMessage = (e) => {
    e.preventDefault();
    setText(e.target.value);
  };

  const addBotMessage = (botMessage) => {
    messages.push(
      botMessage.toKamiObject(),
    );
    setAux(aux + 1);
  };

  const addGroupedBotMessages = (botMessages) => {
    const messageJsObjects = botMessages.map((botMessage) => botMessage.toJsObject());
    messages.push(
      {
        Kami: messageJsObjects,
        id: uuidv4(),
      },
    );
    setAux(aux + 1);
  };

  const handlerSubmit = (e) => {
    setAnalytics('Lesson', 'Btn_EnviarChatBot');
    e.preventDefault();
    const messageUser = {
      User: [
        {
          text,
          createdAt: new Date(),
          id: uuidv4(),
        },
      ],
      id: uuidv4(),
    };
    messages.push(messageUser);
    setAux(aux + 1);

    const botResponse = chatBot.reply(text);
    if (botResponse instanceof BotMessage) {
      addBotMessage(botResponse);
    } else if (botResponse instanceof Array) {
      addGroupedBotMessages(botResponse);
    }

    const isBotResponseFinal = chatBot.finally();
    if (isBotResponseFinal === undefined) {
      setChatStatus('ended');
    }

    setText('');
  };

  return (
    <>
      <ReturnButton />
      <Typography className={classes.title}>Agenda reunión</Typography>
      <CardChat
        messages={messages}
        aux={aux}
        chatStatus={chatStatus}
      />
      <FormControl className={classes.writeandSendMessageForm}>
        <OutlinedInput
          placeholder="Escribir mensaje"
          className={classes.input}
          value={text}
          onChange={(e) => handlerChangeWriteMessage(e)}
        />
        <Button
          size="small"
          type="submit"
          onClick={(e) => handlerSubmit(e)}
          disabled={chatStatus === 'ended'}
          className={classes.sendMessageButton}
        >
          Enviar
        </Button>
      </FormControl>
    </>
  );
}

Chat.propTypes = {
  messages: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.string),
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  chatBot: PropTypes.instanceOf(ChatBot).isRequired,
  chatStatus: PropTypes.string.isRequired,
  setChatStatus: PropTypes.string.isRequired,
};

export default Chat;
